export const techHero = {
  eyebrow: '技术能力',
  title: '三大核心技术能力',
  desc: 'TOMA 智能体、数字货架与云铺、物联网连接，三项技术能力协同，构成面向县域与乡村场景的完整数字商业基础设施。',
};

export const techModules = [
  {
    no: '01',
    icon: 'ri-robot-2-line',
    title: 'TOMA 智能体',
    subtitle: 'AI 交互入口 · 连接人与服务',
    desc: '面向县域用户与实体店的 AI 智能交互入口，将复杂操作转化为对话式体验，承载美食社交、健康管家与数字服务。华辉数智负责 TOMA 掌中智能体开发，并承担核心技术系统的交付与集成。',
    features: ['美食社交', '健康管家', '数字服务', '车载卡激活'],
  },
  {
    no: '02',
    icon: 'ri-store-2-line',
    title: '数字货架与云铺',
    subtitle: '商品展示 · 交易入口 · 数据回流',
    desc: '把分散的县域商品组织成集中的数字货架，实现产品展示、交易入口与数据回流的统一载体；云铺将实体经营转化为数字经营，形成买货卖货服务的完整节点能力。',
    features: ['产品展示', '交易入口', '数据回流', '云社员', '云店'],
  },
  {
    no: '03',
    icon: 'ri-wifi-line',
    title: '物联网连接',
    subtitle: '设备身份 · 状态事件 · 业务节点',
    desc: '连接设备身份、状态事件与业务节点，实现物联网设备与数字商业系统的深度融合，让物理世界的每一个动作都能转化为可运营的数据与业务节点。',
    features: ['设备身份', '状态事件', '业务节点', '数据驱动'],
  },
];

export const dataChainSteps = [
  { icon: 'ri-robot-2-line', label: 'TOMA 智能体', desc: 'AI 交互入口，连接人与服务' },
  { icon: 'ri-store-2-line', label: '数字货架与云铺', desc: '商品展示、交易入口与数据回流' },
  { icon: 'ri-wifi-line', label: '物联网连接', desc: '设备身份、状态事件与业务节点' },
];